<div class="d-flex align-items-center justify-content-between {{tabCssClass ? tabCssClass : ''}}">
  <div class="flex-grow-1">
    <ul ngbNav #nav="ngbNav" class="nav-underline" [ngClass]="{ 'is-admin': reduceHorizontalSpacing}"
        [class.mb-3]="reduceHorizontalSpacing" [(activeId)]="active"
        (navChange)="onNavChange($event)">
      @for (tab of tabs;track tab) {
        <ng-container>
          <li [ngbNavItem]="tab.itemId">
            <a ngbNavLink class="d-flex align-items-center" [class.shorten-underline]="tab.showIndicator">
              {{ tab.title }}
              @if (tab.showIndicator) {
                <ng-container>
                  <app-checkmark-indicator [isChecked]="tab.isChecked"/>
                </ng-container>
              }
            </a>
            <ng-template ngbNavContent>
              <ng-container *ngTemplateOutlet="tab.content"/>
            </ng-template>
          </li>
        </ng-container>
      }
    </ul>
  </div>
  <ng-content/>
</div>

<div [ngbNavOutlet]="nav"></div>
